module.exports = "https://static.wmbcdn.com/uniweb/images/9a696237f6c0a135eda11309260bafba.svg";